/**
 * Input with Inline Start/End Add-on Renderer
 *
 * Text input with prefix and/or suffix text (e.g., currency fields)
 */

import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { FieldRenderer } from '@/MyCode/core';

/**
 * Input Inline Start/End Add-on Renderer
 * Features:
 * - Prefix text (startAddOn) - e.g., "$"
 * - Suffix text (endAddOn) - e.g., "USD"
 * - Perfect for currency, units, etc.
 * - Error states
 */
export const renderInputInlineStartEndAddOn: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    isRequired
}) => (
    <div className="space-y-2">
        <Label htmlFor={field.name}>
            {field.label}
            {isRequired && <span className="text-destructive ml-1">*</span>}
        </Label>
        <div className="relative flex rounded-md shadow-xs">
            {field.ui?.startAddOn && (
                <span className="pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-sm text-muted-foreground">
                    {field.ui.startAddOn}
                </span>
            )}
            <Input
                id={field.name}
                type={field.inputType || 'text'}
                placeholder={field.placeholder}
                value={value || ''}
                onChange={(e) => handleChange(field.name, e.target.value)}
                maxLength={field.maxLength}
                className={`-me-px rounded-e-none ${field.ui?.startAddOn ? 'ps-6' : ''} shadow-none ${hasError ? 'border-destructive' : ''}`}
            />
            {field.ui?.endAddOn && (
                <span className="text-black text-sm text-muted-foreground -z-10 inline-flex items-center rounded-e-md border border-input bg-background px-3">
                    {field.ui.endAddOn}
                </span>
            )}
        </div>
    </div>
);

export default renderInputInlineStartEndAddOn;
